

exports.__esModule = true;
exports.$EmptyCartRoute = undefined;

require('./directive');

var _squid = require('squid');

var $EmptyCartRoute = exports.$EmptyCartRoute = _squid.$ComponentRoute.extend('$EmptyCartRoute', {

    path: 'emptyCart',

    directive: 'xo-empty-cart-page',

    trackingData: {
        fptiState: 'emptyCart',
        templateName: 'emptyCart.dust',
        pageGoal: 'emptyCart page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-emptyCart',
                'pagename2': '%::fullpage-emptyCart:wps:shoppingcart:',
                'version': 'member:%:'
            }
        },
        trackStateExit: true
    },

    auth: false,

    children: []
});

angular.value("$EmptyCartRoute", $EmptyCartRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-empty-cart/route.js
// module id = ./pages/xo-empty-cart/route.js
// module chunks = 1